$(function() {
    $('.js-openProduct').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).parents('.product').toggleClass('open');
    });
});
